export default "__VITE_ASSET__kZhppAuC__"